const axios = require('axios');

export default {
    install(vue){
        const apiKey = 'e4feee93a27f4dfcb61389a562bdb051';

        const GetRandom = () => {
            return vue.$cache.Get('recipes_cache', 60, () => {
                return new Promise(resolve => {
                    axios
                        .get(`https://hmyrecipefinder.co/app/recipes`)
                        .then(response => resolve(response.data.map(obj => {
                            obj['url'] = '/r/' + obj.id;
                            obj['author'] = obj.sourceName;
                            return obj;
                        })));
                });
            })
        }

        const Search = (query, limit = 100) => {
            return axios
                .get(`https://api.spoonacular.com/recipes/complexSearch?apiKey=${apiKey}&query=${query}&number=${limit}&sort=popularity&sortDirection=desc`)
                .then(response => response.data.results.map(obj => {
                    obj['url'] = '/r/' + obj.id;
                    return obj;
                }));
        }

        const GetInformation = (id) => {
            return axios
                .get(`https://api.spoonacular.com/recipes/${id}/information?apiKey=${apiKey}`)
                .then(response => response.data);
        }

        vue.prototype.$recipes = {
            GetRandom,
            Search,
            GetInformation
        };
        vue.$recipes = {
            GetRandom,
            Search,
            GetInformation
        };
    }
}